import { Environments } from '../../../../types/global';
export const endpoints = {
    [Environments.Mainnet]: 'https://runebridge.sovryn.app',
    [Environments.Testnet]: 'https://runebridge.test.sovryn.app',
};
